import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IProductDataV2 } from '@df/catalog/product/product';
import { Customer } from '@df/session/api/customer';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from '../../../model/product/product.decorator';
@Component({
    selector: 'product-view-price',
    templateUrl: './product-view-price.html',
    standalone: true,
    imports: [TranslationModule, PriceComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewPriceComponent {
    @Input()
    product: LocalProduct<IProductDataV2>;
    constructor(customer: Customer, changeDetectorRef: ChangeDetectorRef) {
        customer.model.obs.status.pipe(takeUntilDestroyed()).subscribe(() => changeDetectorRef.detectChanges());
    }
}
